const SigninDetails = () => {
    return (
        <div className="signin-details w-full max-w-[600px] text-white justify-center items-center">
            <div className=" flex flex-col gap-[10px]">
                {/* <Logo className="mb-10 lg:mr-0" /> */}
                <img
                    className="w-[100%] h-[100%] -mt-[20px]"
                    alt="main"
                    src="/images/bg-app.png"
                ></img>
                <span className="font-semibold text-lg w-[100%] text-center ">
                    Intelligent Contact Centers: Where AI Meets Customer
                    Experience
                </span>

                <p className="w-[100%] text-base text-center">
                    &copy; Copyright {new Date().getFullYear()}. All Rights
                    Reserved.
                </p>
            </div>
        </div>
    );
};

export default SigninDetails;
